import microApps from '@/common/qiankun';

export const getSubAppNameByPath = path => {
    if (Array.isArray(microApps) && microApps.length > 0) {
        const subApp = microApps.find(app => {
            const { activeRule } = app;
            if (activeRule) {
                return new RegExp(activeRule).test(path);
            }
            return false;
        });
        if (subApp) {
            return subApp.name;
        }
        return '';
    }
    return '';
};
